import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import { Button, Form, Grid, Header, Segment, Message, Icon } from "semantic-ui-react";
import { login } from "../../api/apiuser";
const apiUrl = process.env.REACT_APP_API_URL;
const apiCode = process.env.REACT_APP_API_CODE;

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true); // Show loading spinner

    try {

      // Call the login function
      const result = await login(username, password);

      // If login is successful
      if (result?.loginSuccess === true) {

        // Redirect to the Overview page
        navigate("/Home");
      } else {
        alert("Issue with sign in. Check your username and password, if the issue continues please contact support@elius.dk")
      }
    } catch (err) {
      setError("Error logging in. Please try again.");
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  return (
    <Grid
      textAlign="center"
      style={{ height: "100vh" }}
      verticalAlign="middle"
    >
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" color="teal" textAlign="center">
          <Icon name="lock" /> Log-in to your account
        </Header>
        <Form size="large" onSubmit={handleLogin} error={!!error}>
          <Segment stacked>
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {error && <Message error content={error} />}

            <Button color="teal" fluid size="large" loading={loading} disabled={loading}>
              Login
            </Button>
          </Segment>
        </Form>
        {/* <Message>
          New to us? <a href="#">Sign Up</a>
        </Message> */}
      </Grid.Column>
    </Grid>
  );
};

export default Login;
